export default function Recommendation() {
  return (
    <>
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.02198 4.84668C5.34035 5.36327 4.69546 5.92663 4.09198 6.53268C1.24798 9.37668 -0.192024 12.5457 0.873976 13.6127C1.93998 14.6787 5.10998 13.2377 7.95298 10.3947C8.55906 9.79088 9.12242 9.14565 9.63898 8.46368"
          stroke="#F8F8F8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.63898 8.46352C11.316 10.6895 11.999 12.7835 11.171 13.6115C10.104 14.6785 6.93498 13.2375 4.09098 10.3945C1.24898 7.54952 -0.191025 4.38152 0.874975 3.31452C1.70298 2.48752 3.79697 3.17052 6.02297 4.84652"
          stroke="#F8F8F8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.52197 8.46376C5.52197 8.59637 5.57465 8.72355 5.66842 8.81732C5.76219 8.91108 5.88936 8.96376 6.02197 8.96376C6.15458 8.96376 6.28176 8.91108 6.37553 8.81732C6.46929 8.72355 6.52197 8.59637 6.52197 8.46376C6.52197 8.33115 6.46929 8.20398 6.37553 8.11021C6.28176 8.01644 6.15458 7.96376 6.02197 7.96376C5.88936 7.96376 5.76219 8.01644 5.66842 8.11021C5.57465 8.20398 5.52197 8.33115 5.52197 8.46376ZM8.03197 4.10976C7.71697 4.05476 7.71697 3.60376 8.03197 3.54976C8.58831 3.45298 9.10323 3.19272 9.51108 2.80215C9.91892 2.41158 10.2012 1.9084 10.322 1.35676L10.34 1.26976C10.408 0.959762 10.85 0.957762 10.92 1.26676L10.944 1.36776C11.0692 1.91696 11.354 2.41688 11.7625 2.80474C12.171 3.1926 12.685 3.4511 13.24 3.54776C13.556 3.60276 13.556 4.05676 13.24 4.11076C12.685 4.20742 12.171 4.46592 11.7625 4.85378C11.354 5.24164 11.0692 5.74157 10.944 6.29076L10.92 6.39176C10.85 6.70176 10.408 6.69976 10.34 6.38976L10.32 6.30276C10.1992 5.75113 9.91693 5.24795 9.50908 4.85738C9.10123 4.46681 8.58631 4.20654 8.02997 4.10976H8.03197Z"
          stroke="#F8F8F8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
